import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react';
import { ScoreDetailService } from '../../../../../common/services';
import { runInAction, toJS } from 'mobx';
import WebSocketUtil from '../../../../../common/utils/socketUtil';
import ChampWebSocketUtil from '../../../../../common/utils/champSocketUtil';
import MatchCheerCommentModel from './model';
import Cookie from '../../../../../common/utils/cookie';
import useModalStore from '../../../../../hooks/useModalStore';

const MatchCheerStore = () => {
  const modalStore = useModalStore();

  const store = useLocalStore(() => ({
    comments: [],
    powerChat: {
      comments: [],
      totalCount: 0,
      currentSlide: 1
    },
    loading: true,
    init: false,
    socket: null,
    isSub: false,
    gameId: null,
    sportsType: null,
    sportsId: null,
    page: 1,
    total_cnt: 0,
    ref: null,
    report: {
      is_real: false,
      is_fake: false,
      is_crime: false
    },
    isAll: Cookie.getCookie('isViewAllCheer') || false,

    champSocket: null,
    champIsSub: false,
    champGameId: null,
    champComments: [],

    connectSocket(topic) {
      store.socket = new WebSocketUtil(topic);
      store.socket.ws.onmessage = (event) => {
        if (event) {
          let data = event.data;
          try {
            if (data === 'OK') {
              store.isSub = true;
            } else {
              let messageData = JSON.parse(data);
              if (messageData) {
                const { TOPIC, MESSAGE } = messageData;
                const data = JSON.parse(MESSAGE);
                if (!data.is_admin) data.ws = true;
                if (store.gameId !== data.game_id) data.differentGame = true;

                const commentData = new MatchCheerCommentModel(data);

                if (data.message_type === 'POWER_CHAT') {
                  store.powerChat.totalCount =
                    parseInt(store.powerChat.totalCount) + 1;
                  store.powerChat.comments.splice(
                    store.powerChat.currentSlide,
                    0,
                    commentData
                  );
                  if (
                    store.ref.scrollHeight - store.ref.scrollTop <=
                    store.ref.clientHeight + 10
                  ) {
                    setTimeout(
                      () => (store.ref.scrollTop = store.ref.scrollHeight),
                      100
                    );
                  }
                }

                store.comments = [commentData, ...store.comments];

                if (
                  store.ref.scrollHeight - store.ref.scrollTop <=
                  store.ref.clientHeight + 10
                ) {
                  setTimeout(
                    () => (store.ref.scrollTop = store.ref.scrollHeight),
                    100
                  );
                }
              }
            }
          } catch (error) {
            console.log('=== socket on message error ===', error);
          }
        }
      };
    },
    closeSocket() {
      if (!!store.socket) {
        store.socket.close(() => {
          runInAction(() => {
            store.isSub = false;
            store.socket = null;
          });
        });
      }
    },

    champConnectSocket(topic) {
      store.champSocket = new ChampWebSocketUtil(topic);
      store.champSocket.ws.onmessage = (event) => {
        if (event) {
          let data = event.data;
          try {
            if (data === 'OK') {
              store.champisSub = true;
            } else {
              let messageData = JSON.parse(data);
              if (messageData) {
                const { TOPIC, MESSAGE } = messageData;
                const data = JSON.parse(MESSAGE);

                const commentData = new MatchCheerCommentModel(data);
                if (commentData.is_admin) return;

                commentData.isChamp = true;

                if (
                  store.ref.scrollHeight - store.ref.scrollTop <=
                  store.ref.clientHeight + 150
                ) {
                  setTimeout(
                    () => (store.ref.scrollTop = store.ref.scrollHeight),
                    100
                  );
                }

                store.comments = [commentData, ...store.comments];
              }
            }
          } catch (error) {
            console.log('=== socket on message error ===', error);
          }
        }
      };
    },
    closeChampSocket() {
      if (!!store.champSocket) {
        store.champSocket.close(() => {
          runInAction(() => {
            store.champisSub = false;
            store.champSocket = null;
          });
        });
      }
    },

    setRef(ref) {
      store.ref = ref;
    },

    changeViewMode(value) {
      store.isAll = value;
      this.closeSocket();
      setTimeout(() => {
        if (value) {
          store.connectSocket([
            'sports.soccer.cheers',
            'sports.baseball.cheers',
            'sports.basketball.cheers',
            'sports.volleyball.cheers',
            'sports.football.cheers',
            'sports.hockey.cheers',
            'sports.star.cheers',
            'sports.lol.cheers'
          ]);
          Cookie.setUserCookie('isViewAllCheer', true);
        } else {
          store.connectSocket([
            `sports.${store.sportsType}.cheers.${store.gameId}`
          ]);
          Cookie.deleteCookie('isViewAllCheer');
        }
      }, 100);
    },
    async getCheerList(gameId, sportsType, sportsId, page = 1) {
      store.loading = true;
      store.gameId = gameId;
      store.sportsType = sportsType;
      store.sportsId = sportsId;

      if (!store.isSub) {
        if (store.isAll) {
          store.connectSocket([
            'sports.soccer.cheers',
            'sports.baseball.cheers',
            'sports.basketball.cheers',
            'sports.volleyball.cheers',
            'sports.football.cheers',
            'sports.hockey.cheers',
            'sports.star.cheers',
            'sports.lol.cheers'
          ]);
        } else {
          store.connectSocket([
            `sports.${sportsType}.cheers${gameId ? `.${gameId}` : ''}`
          ]);
        }
      }

      try {
        const result = await ScoreDetailService.getCheerList(
          gameId,
          sportsId,
          page
        );

        if (!!result) {
          store.total_cnt = result.total_cnt;
        }

        if (result.list.length > 0) {
          const list = result.list.map(
            (item) => new MatchCheerCommentModel(item)
          );
          const filteredChampList = store.champComments.filter((item) => {
            return (
              item.createAtMoment >= list[list.length - 1].createAtMoment &&
              !item.is_admin
            );
          });

          store.comments = list.concat(filteredChampList).sort((a, b) => {
            return b.createAtMoment - a.createAtMoment;
          });
        } else {
          store.comments = [...store.champComments];
        }

        if (result.power_chat.list.length > 0) {
          store.powerChat.comments = result.power_chat.list.map(
            (item) => new MatchCheerCommentModel(item)
          );
          store.powerChat.totalCount = result.power_chat.total_cnt;
        }
      } catch (e) { }
      store.loading = false;
    },
    async getCheerMore(height) {
      const { page, total_cnt, gameId, sportsId } = store;
      const maxPage = Math.ceil(total_cnt / 200) || 1;
      let nextPage = page + 1;

      if (nextPage > maxPage) {
        const filteredChampList = store.champComments.filter((item) => {
          return (
            item.createAtMoment <
            store.comments[store.comments.length - 1].createAtMoment &&
            !item.is_admin
          );
        });
        store.comments = [...store.comments, ...filteredChampList];
        setTimeout(() => {
          store.ref.scrollTop = store.ref.scrollHeight - height;
        }, 1);
        return;
      } else {
        store.page = nextPage;
      }

      const result = await ScoreDetailService.getCheerList(
        gameId,
        sportsId,
        nextPage
      );

      if (result.list.length > 0) {
        const addList = result.list.map(
          (item) => new MatchCheerCommentModel(item)
        );
        const filteredChampList = store.champComments.filter((item) => {
          return (
            item.createAtMoment <
            store.comments[store.comments.length - 1].createAtMoment &&
            item.createAtMoment >= addList[addList.length - 1].createAtMoment &&
            !item.is_admin
          );
        });

        store.comments = store.comments
          .concat(filteredChampList, addList)
          .sort((a, b) => {
            return b.createAtMoment - a.createAtMoment;
          });

        setTimeout(
          () => (store.ref.scrollTop = store.ref.scrollHeight - height),
          1
        );
      }
    },
    async postCheerComment(param) {
      const data = {
        ...param,
        sportsId: store.sportsId
      };

      const result = await ScoreDetailService.postCheer(store.gameId, data);

      return result;
    },
    async getCheerCommentReport(targetId, gameId) {
      const result = await ScoreDetailService.getCommentReport(
        targetId,
        gameId,
        store.sportsId
      );
      if (result) {
        store.report = result;
      }
    },
    async postCheerCommentReport(param) {
      const data = {
        ...param,
        sports_id: store.sportsId
      };

      const result = await ScoreDetailService.postCommentReport(data);

      if (result.status === 200) {
        store.report = result.data;
      }

      return result;
    },
    async deletePowerChat(chat, index) {
      const result = await ScoreDetailService.deleteCheer(chat);
      if (result.status === 200) {
        store.powerChat.comments.splice(index, 1);
        store.powerChat.totalCount = store.powerChat.totalCount - 1;
      } else {
        modalStore.openAlertModal({
          message: result.data.message
        });
      }
    },
    changeCurrentSlide(index) {
      store.powerChat.currentSlide = index + 1;
    }
  }));

  return {
    getCheerList: store.getCheerList,
    getCheerMore: store.getCheerMore,
    postCheerComment: store.postCheerComment,
    getCheerCommentReport: store.getCheerCommentReport,
    postCheerCommentReport: store.postCheerCommentReport,
    closeSocket: store.closeSocket,
    closeChampSocket: store.closeChampSocket,
    setRef: store.setRef,
    changeCurrentSlide: store.changeCurrentSlide,
    changeViewMode: store.changeViewMode,
    deletePowerChat: store.deletePowerChat,
    data: useObserver(() => {
      return {
        init: store.init,
        loading: store.loading,
        comments: store.comments.reverse(),
        report: store.report,
        powerChat: store.powerChat
      };
    }),
    isAll: useObserver(() => store.isAll)
  };
};

export default MatchCheerStore;
